module.exports = __webpack_public_path__ + "static/media/user.f700aaf6.svg";